module.exports = __webpack_public_path__ + "static/media/balloon2.89500787.png";


//////////////////
// WEBPACK FOOTER
// ./src/balloon2.png
// module id = 174
// module chunks = 0